export enum TakersRoutesEnum{
    TAKERS_LIST           = 'takers-list',
    TAKERS_DETAIL         = 'takers-detail',
    TAKERS_ZONE           = 'takers-zone',
    TAKERS_AVAILABILITIES = 'takers-availabilities',
    
    AVAILABILITY          = 'availability',

}